"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Ads API
 * The Spotify Ads API.
 *
 * The version of the OpenAPI document: 3.0.0
 * Contact: selfserve-infra-api@spotify.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPixelResponseToJSON = exports.MapPixelResponseFromJSONTyped = exports.MapPixelResponseFromJSON = exports.instanceOfMapPixelResponse = void 0;
var runtime_1 = require("../runtime");
var MapRequestState_1 = require("./MapRequestState");
/**
 * Check if a given object implements the MapPixelResponse interface.
 */
function instanceOfMapPixelResponse(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfMapPixelResponse = instanceOfMapPixelResponse;
function MapPixelResponseFromJSON(json) {
    return MapPixelResponseFromJSONTyped(json, false);
}
exports.MapPixelResponseFromJSON = MapPixelResponseFromJSON;
function MapPixelResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'id': !(0, runtime_1.exists)(json, 'id') ? undefined : json['id'],
        'state': !(0, runtime_1.exists)(json, 'state') ? undefined : (0, MapRequestState_1.MapRequestStateFromJSON)(json['state']),
    };
}
exports.MapPixelResponseFromJSONTyped = MapPixelResponseFromJSONTyped;
function MapPixelResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'id': value.id,
        'state': (0, MapRequestState_1.MapRequestStateToJSON)(value.state),
    };
}
exports.MapPixelResponseToJSON = MapPixelResponseToJSON;
